<i18n>
{
  "en": {
    "create-shop": "Create Shop"
  },
  "th": {
    "create-shop": "สร้างร้านค้า"
  }
}
</i18n>
<template>
  <div>
    <v-btn depressed
           x-large
           class="subtitle-1 font-weight-regular pink--text mr-8 d-inline"
           @click="buttonClick"
    >{{ $t('create-shop') }}
    </v-btn>
  </div>
</template>

<script>
import helpers from '../mixins/helpers'
import { mapMutations } from 'vuex'

export default {
  name: 'PaowCreateShopButton',
  mixins: [helpers],
  methods: {
    ...mapMutations([
      'shop/setShowCreatShopDialog'
    ]),
    buttonClick () {
      this['shop/setShowCreatShopDialog'](true)
    }
  }
}
</script>

<style>

</style>
